
<template>
  <div class="collection-sidebar" v-if="filtersDisabled !== 1">
    <collection-filters-b :tags="tags" :filters="filters"></collection-filters-b>
  </div>
</template>

<script>
import VLink from '@/scripts/components/buttons/VLink.vue'

import CollectionFiltersB from './CollectionFiltersB.vue'

export default {
  name: 'CollectionSidebarB',
  components: { CollectionFiltersB, VLink },
  props: {
    defaultSort: String,
    filtersDisabled: {
      type: Number,
      default: 0
    },
    tags: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
  .collection-sidebar {
    min-width: 312px;
    margin-top: 32px;
    margin-right: 32px;
    padding-left: 18px;

    &__global-menu {
      display: flex;
      flex-direction: column;
      padding: 24px 0 16px;
      .top-level {
        border-bottom: 1px solid $color-grey;
        padding: 12px 0 6px;
        font-weight: 600;
        color: $color-black;
      }
      .collection-sidebar__custom-menu-item {
        color: $color-black;
        font-size: 12px;
        font-family: $font-family-primary;
      }

      > a:visited {
        color: $color-black;
      }
    }
    &__custom-menu {
      display: flex;
      flex-direction: column;
      .top-level {
        border-bottom: 1px solid $color-grey;
        padding: 12px 0 6px;
        font-weight: 600;
        color: $color-black;
      }
      .collection-sidebar__custom-menu-item {
        padding: 12px 0 6px;
        font-weight: 600;
        color: $color-black;
        font-size: 12px;
        font-family: $font-family-primary;
      }
    }
  }
  .remove-bottom-spacing {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
</style>
